import { RecordType } from "./RecordType";

export default RecordType;
